<!--
 * @Author: lsr lsr@qq.com
 * @Date: 2022-07-09 11:46:07
 * @LastEditors: lsr lsr@qq.com
 * @LastEditTime: 2022-07-09 14:03:46
 * @FilePath: \YHB_H5\src\pages\download\sysdownload.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div v-if="browser == false" class="download-content">
		<img src="../../assets/xfs-down-bg.png" class="bg" />
		<div class="download-bottom" @click="download">
			<div><img class="xfs-btn" src="../../assets/xfs-btn.png" alt="" /></div>
			<div>下载幸福刷APP</div>
		</div>
	</div>
	<div v-else class="download-content"><img @click="browser = false" src="../../assets/xfs-down-close.png" class="bg" /></div>
</template>

<script>
import { downloadApps } from '@/api/index';
// import { Toast } from 'vant';

export default {
	data() {
		return {
			browser: false
		};
	},
	mounted() {
		// this.getisweixing();
	},

	methods: {
		// 判断是否在 微信浏览器
		getisweixing() {
			var wx = window.navigator.userAgent.toLowerCase();
			if (wx.match(/MicroMessenger/i) == 'micromessenger') {
				// console.log('是微信浏览器默认走微信')
				this.browser = true;
				return; // 是微信端
			} else {
				// console.log('不是微信浏览器绘制原生。');
				this.browser = false;
				return;
			}
		},
		// 下载
		async download() {
			await this.getisweixing();
			if (this.browser) {
				// Toast({
				// 	message: '请点击右上角选择在浏览器中打开',
				// 	duration: 3000
				// });
				return;
			}
			downloadApps('XFS').then(res => {
				let u = navigator.userAgent;
				let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
				if (isAndroid) {
					window.location.href = res.msg;
				} else {
					window.location.href = `itms-apps://itunes.apple.com/app/id6474218761?mt=8`
				}
			});
		}
	}
};
</script>

<style lang="scss">
.download-content {
	position: relative;
	// // max-width: 750px;
	// margin: auto;
	// height: 100%;
	// position: relative;
	// max-width: 750px;
	// margin: auto;
	height: 100%;
	max-width: 100%;
}

.bg {
	max-width: 100%;
	height: 100%;
	// max-width: 100%;
	width: 100%;
}

.download-bottom {
	position: absolute;
	bottom: 15%;
	right: 50%;
	transform: translateX(50%);
	display: flex;
	width: 200px;
	margin: 0 auto;
	text-align: center;
	color: #fff;
	height: 60px;
	background: linear-gradient(107deg, #FB4747 0%, #C9221D 100%);
	line-height: 60px;
	box-shadow: 2px 10px 24px 1px rgba(255,105,14,0.29);
	border-radius: 12px 12px 12px 12px;
	.xfs-btn{
		width: 51px;
		height: 42px;
	}
}
</style>
